(function () {
  function initWeglotAccordionRefresh() {
    if (!window.Weglot) return;

    document.addEventListener('click', function (e) {
      if (e.target.closest('.reward-faq-accordion-header')) {
        Weglot.refresh();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWeglotAccordionRefresh);
  } else {
    initWeglotAccordionRefresh();
  }
})();
